/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Action_KeyInputs */

const cs_audit_action_key = /** @type {(inputs: Audit_Action_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíč akce`)
};

const en_audit_action_key = /** @type {(inputs: Audit_Action_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action key`)
};

/**
* | output |
* | --- |
* | "Action key" |
*
* @param {Audit_Action_KeyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_action_key = /** @type {((inputs?: Audit_Action_KeyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Action_KeyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_action_key(inputs)
	return cs_audit_action_key(inputs)
});